import { BrowserRouter } from "react-router-dom"
import { HashLink as Link} from "react-router-hash-link"
import "../component_style/Nav.css"
import React from "react"

import { Show, Hide } from '@chakra-ui/react'
import Logo from "../image/n.jpg"
import Nav_com from "./navbar.comp"
import Nav_ham from "./hambergut"

export default function Navbar(){

    return (<>
     <Hide breakpoint='(max-width: 500px)'>    
      <Nav_com/>
    </Hide>
    <Show breakpoint='(max-width: 500px)'>
      <Nav_ham/>
    </Show>
  
    </>
    )
}